import { cn } from '@/lib/utils';
import { ITicketData, ticketType } from '@/types';
import Moment from 'moment';
import TicketIconType from './TicketIconType';

const stringToEnum: Record<string, ticketType> = {
  chat: ticketType.chat,
  user: ticketType.user,
  book: ticketType.book,
  bug: ticketType.bug,
};
interface ticketCardProps {
  ticket: ITicketData;
  isActive: boolean;
}

export default function TicketCard({ ticket, isActive = false }: ticketCardProps) {
  const { ticket_type, reason, ticket_code, createdAt, ticket_status } = ticket;

  const convertedType = stringToEnum[ticket_type];

  return (
    <div
      className={cn(
        'mx-2 my-1 flex justify-between gap-2 rounded-lg px-3 py-2.5 transition-colors',
        isActive
          ? 'bg-primary-light border border-primary/20'
          : 'group hover:bg-coal-100'
      )}
    >
      <div className="flex flex-col gap-1 text-primary group-hover:text-primary">
        <TicketIconType type={convertedType} />
        <span
          className={cn(
            'inline-block h-2 w-2 self-center rounded-full',
            ticket_status === 'pending' ? 'bg-warning' : 'bg-success'
          )}
        ></span>
      </div>
      <div className="flex flex-1 flex-col">
        <div className="flex justify-between">
          <span className="text-sm font-medium text-coal-700 group-hover:text-coal-900">#{ticket_code}</span>
          <p className="text-2xs text-coal-400">
            {Moment(createdAt).fromNow()}
          </p>
        </div>
        <p className="line-clamp-1 text-xs text-coal-400 group-hover:text-coal-500">
          {reason}
        </p>
      </div>
    </div>
  );
}
